import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { guid, shallowEqual, shallowMerge } from '@tencent/glue-util-helper';
import { Emitter } from '@tencent/glue-util-emitter';
export var GroupItem = /*#__PURE__*/function (_Emitter) {
  _inherits(GroupItem, _Emitter);

  var _super = _createSuper(GroupItem);

  function GroupItem(ownerGroup, conf) {
    var _this;

    _classCallCheck(this, GroupItem);

    _this = _super.call(this); // 所属编号

    _this.id = guid(); // 当前是否已经销毁

    _this.disposed = false;

    _this.onChange = function (checked) {
      _this.ownerGroup.onItemChange(_assertThisInitialized(_this), checked);
    };

    _this.group = conf.group;
    _this.value = conf.value;
    _this.disabled = conf.disabled;
    _this.free = Boolean(conf.free);
    _this.onSelect = conf.onSelect;
    _this.ownerGroup = ownerGroup;

    _this.ownerGroup.register(_assertThisInitialized(_this));

    _this.extraProps = conf.extraProps;
    return _this;
  } // 获取渲染配置


  _createClass(GroupItem, [{
    key: "getGroupItemInfo",
    value: function getGroupItemInfo(conf) {
      this.updateOptions(conf);
      var disabled = this.ownerGroup.disabled || conf.disabled;
      var extraProps = shallowMerge(this.ownerGroup.extraProps, conf.extraProps);
      return [_objectSpread({
        disabled: disabled,
        checked: this.ownerGroup.isItemChecked(this)
      }, extraProps), this.onChange];
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (!this.disposed) {
        this.disposed = true;
        this.ownerGroup.unregister(this);
      }
    }
  }, {
    key: "emitGroupChange",
    value: function emitGroupChange() {
      this.emit('group-change');
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      var shouldUpdateExtraProps = options.extraProps != null && !shallowEqual(this.extraProps, options.extraProps);

      if (options.group !== this.group || options.value !== this.value || options.disabled !== this.disabled || shouldUpdateExtraProps) {
        this.ownerGroup.unregister(this);
        this.group = options.group;
        this.value = options.value;
        this.disabled = options.disabled;
        this.extraProps = options.extraProps;
        this.ownerGroup.register(this);
      }
    }
  }]);

  return GroupItem;
}(Emitter);